import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
    CmpsButtonModule,
    CmpsIconModule,
    CmpsRadioModule,
} from '@cmps/ng-uikit';

import { CmpsCommonModule } from '../../common/common.module';
import { CmpsDateTimePickerModule } from '../../common/component/datetime-picker';
import { CmpsLazyI18nModule } from '../../i18n/i18n.module';
import { CmpsLazyRouterModule } from '../../route.module';
import { CmpsUserModule } from '../../user/user.module';
import { CmpsCardModule } from '../card';
import { CmpsEvalFormModule } from '../form';
import { ExperimentalNgGridModule } from '../grid';

import { SearchComponent } from './search.component';
import { TranslationIdMap } from './search.i18n';
import { SearchRoutes } from './search.route';

@NgModule({
    declarations: [SearchComponent],
    exports: [SearchComponent],
    imports: [
        CmpsButtonModule,
        CmpsCardModule,
        CmpsCommonModule,
        CmpsDateTimePickerModule,
        CmpsEvalFormModule,
        CmpsIconModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsLazyRouterModule.forChild(SearchRoutes),
        CmpsRadioModule,
        CmpsUserModule,
        CommonModule,
        ExperimentalNgGridModule,
        FormsModule,
    ],
})
export class CmpsEvalSearchModule {}
